import React, { ChangeEvent, Dispatch, FormEvent, SetStateAction, useRef } from 'react';
import { IconButton, Typography, Paper, Button } from '@mui/material';
import CachedIcon from '@mui/icons-material/Cached';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

type PromoUploadExcelPropsType = {
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
  setFile: Dispatch<SetStateAction<File | null>>;
  file: File | null;
};

export const PromoUploadExcel = ({ onSubmit, setFile, file }: PromoUploadExcelPropsType) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0] || null;
    setFile(selectedFile);
  };

  const handleRefreshIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <Paper
        elevation={3}
        sx={{ padding: '10px', marginBottom: '10px', display: 'flex', alignItems: 'center' }}
      >
        {file ? (
          <>
            <Typography
              variant="subtitle1"
              sx={{ flexGrow: 1 }}
            >
              {file.name}
            </Typography>
            <IconButton onClick={handleRefreshIconClick}>
              <CachedIcon />
            </IconButton>
          </>
        ) : (
          <>
            <Typography
              variant="subtitle1"
              color="textSecondary"
              sx={{ flexGrow: 1 }}
            >
              Загрузите файл
            </Typography>
            <IconButton onClick={handleRefreshIconClick}>
              <FileDownloadIcon />
            </IconButton>
          </>
        )}
      </Paper>
      <input
        type="file"
        accept=".xlsx"
        style={{ display: 'none' }}
        id="file-input"
        onChange={handleFileChange}
        ref={fileInputRef}
      />
      <label
        htmlFor="file-input"
        style={{ display: 'none' }}
      >
        <Button
          variant="contained"
          component="span"
        >
          Выбрать файл
        </Button>
      </label>
      <Button
        type="submit"
        variant="contained"
        disabled={!file}
      >
        Загрузить
      </Button>
    </form>
  );
};
